<section class="no-selected-chat">
  <div class="container">
    <span class="logo" aria-hidden="true">
      <svg viewBox="0 0 303 172" width="320" fill="none">
        <path fill="#daf7f3" d="M229.221 13.07a5.6 5.6 0 0 0-3.946-1.633h-.06a5.601 5.601 0 0 0-3.952 1.687l-67.05 67.05a8.78 8.78 0 0 0 0 12.434l52.057 52.057a8.78 8.78 0 0 0 12.435 0l67.05-67.049a5.601 5.601 0 0 0 0-7.917L229.221 13.07Z"/>
        <circle cx="151.5" cy="86" r="60" fill="#00bfa5"/>
        <path fill="#fff" d="M134 76h35v6h-35zM134 88h35v6h-35zM134 100h22v6h-22z"/>
      </svg>
    </span>

    <div class="text-container">
      <h1>Indi Web</h1>
      <div>
        Selecciona un chat para empezar a conversar.
      </div>
      <div class="end-to-end">
        <span aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
        </span>
        Conexión segura con el banco
      </div>
    </div>
  </div>
</section>
